import React from 'react'
import { useIntl } from 'react-intl'

// utils
import { formatPrice } from '../../utils/helper'

// types
import { Price } from '../../types/types'

// styles
import * as SC from './RenderPriceStyles'

// components
import VisuallyHidden from '../../atoms/VisuallyHidden/VisuallyHidden'

type Props = {
	from?: Price | null
	to?: Price | null
	fromSecondary?: Price | null
	toSecondary?: Price | null
	className?: string
}

const RenderPrice = (props: Props): React.ReactNode => {
	const { from, to, fromSecondary, toSecondary, className } = props
	const { formatMessage } = useIntl()
	const formattedPrice = formatPrice({ from, to, fromSecondary, toSecondary })

	if (!formattedPrice) {
		return null
	}

	const accessiblePrice = formatMessage({ id: 'Price: {price}', defaultMessage: 'Price: {price}' }, { price: formattedPrice })

	return (
		<SC.RenderPriceContainer className={className}>
			<span aria-hidden>{formattedPrice}</span>
			<VisuallyHidden>{accessiblePrice}</VisuallyHidden>
		</SC.RenderPriceContainer>
	)
}

export default RenderPrice
